import React from 'react';
import useAuth from '../hooks/useAuth';
import AdminDashboard from './AdminDashboard';
import OutletDashboard from './OutletDashboard';

const Home = () => {

    const { user } = useAuth()

    return (
        <div className='bg-brand'>
            {
                user.role === 1 ? <AdminDashboard /> : <OutletDashboard />
            }
        </div>
    );
};

export default Home;